export default __webpack_public_path__ + "static/media/enroll.ecc060bf.png";